import { Hero } from '@/components/blog/Hero';
import { PostList } from '@/components/blog/PostList';
import { CategoryGrid } from '@/components/blog/CategoryGrid';
import { Container } from '@/components/ui/Container';
import { Seo } from '@/components/seo/Seo';
import { usePosts, useFeaturedPosts, useCategories } from '@/hooks/usePosts';
import { siteConfig } from '@/data/site';

export const HomePage = (): React.JSX.Element => {
  const { posts: allPosts, isLoading }     = usePosts();
  const { posts: featuredPosts }           = useFeaturedPosts();
  const { categories }                     = useCategories();
  const latestPosts                        = allPosts.slice(0, 6);

  return (
    <>
      <Seo title="Home" description={siteConfig.description} path="/" />
      <Hero />
      <Container>
        {isLoading ? (
          <p style={{ padding: '4rem 0', textAlign: 'center', color: 'var(--cream-3)' }}>
            Loading posts…
          </p>
        ) : (
          <>
            <section className="section-stack">
              <div className="section-heading">
                <h2>Featured</h2>
                <p>Start with the core ideas.</p>
              </div>
              <PostList posts={featuredPosts} />
            </section>

            <section className="section-stack">
              <div className="section-heading">
                <h2>Latest posts</h2>
                <p>New writing on governed content, canonical models, and product updates.</p>
              </div>
              <PostList posts={latestPosts} />
            </section>

            <section className="section-stack">
              <div className="section-heading">
                <h2>Categories</h2>
                <p>Browse by theme.</p>
              </div>
              <CategoryGrid categories={categories} />
            </section>
          </>
        )}
      </Container>
    </>
  );
};
